// Shared visual tokens for broadcast announcements (used by the live
// BroadcastCenter and by the superadmin compose preview, so both look the same).
import { Info, CheckCircle2, AlertTriangle, OctagonAlert } from "lucide-react";

export const SEVERITY_META = {
  INFO: { icon: Info, light: { fg: "#1e5f8f", bg: "#eef6fc", border: "#bcdaf0", accent: "#2e7cba" }, dark: { fg: "#9fcbef", bg: "rgba(46,124,186,0.16)", border: "rgba(46,124,186,0.45)", accent: "#4b9ad6" } },
  SUCCESS: { icon: CheckCircle2, light: { fg: "#065f46", bg: "#ecfdf5", border: "#a7f3d0", accent: "#10b981" }, dark: { fg: "#86efac", bg: "rgba(16,185,129,0.15)", border: "rgba(16,185,129,0.45)", accent: "#34d399" } },
  WARNING: { icon: AlertTriangle, light: { fg: "#92400e", bg: "#fffbeb", border: "#fcd34d", accent: "#f59e0b" }, dark: { fg: "#fcd34d", bg: "rgba(245,158,11,0.14)", border: "rgba(245,158,11,0.45)", accent: "#fbbf24" } },
  CRITICAL: { icon: OctagonAlert, light: { fg: "#991b1b", bg: "#fef2f2", border: "#fca5a5", accent: "#dc2626" }, dark: { fg: "#fca5a5", bg: "rgba(220,38,38,0.16)", border: "rgba(239,68,68,0.5)", accent: "#f87171" } },
};

export const severityColors = (severity, theme) => {
  const meta = SEVERITY_META[severity] || SEVERITY_META.INFO;
  return theme === "dark" ? meta.dark : meta.light;
};

export const SEVERITY_RANK = { CRITICAL: 0, WARNING: 1, INFO: 2, SUCCESS: 3 };

/** Pick the right language, falling back to English when Arabic is blank. */
export const localized = (b, language) => {
  const ar = language === "ar";
  return {
    title: (ar && b.titleAr) || b.titleEn || "",
    body: (ar && b.bodyAr) || b.bodyEn || "",
    dir: ar && (b.titleAr || b.bodyAr) ? "rtl" : "ltr",
  };
};

export const BROADCAST_STRINGS = {
  en: { acknowledge: "I acknowledge", close: "Close", dismiss: "Dismiss", more: (n) => `+${n} more announcement${n === 1 ? "" : "s"}`, announcement: "Announcement" },
  ar: { acknowledge: "تم الاطلاع", close: "إغلاق", dismiss: "إخفاء", more: (n) => `+${n} إعلانات أخرى`, announcement: "إعلان" },
};
